<div class="fill_screen animated fadeInDown" *ngIf="isVisible">
  <div class="inner_waiting">
    <h1
      *ngIf="!showTimeOutError"
      [ngClass]="{ hideLoadingTitle: showCompleteAnimation }"
    >
      {{ title | translate }}
    </h1>
    <h1 *ngIf="showTimeOutError">Der opstod en fejl</h1>
    <app-complete-animation
      *ngIf="showCompleteAnimation && !awaitAnimation"
    ></app-complete-animation>
    <div
      class="loading_screen animated-fadeOut"
      [ngClass]="{ showLoading: !showCompleteAnimation }"
    >
      <div class="loading_area">
        <div
          class="step"
          *ngFor="let step of steps; let i = index"
          [ngClass]="{
            completed_step:
              step.state === 'COMPLETED' || step.key === currentLoadingStep,
            step_loading: step.key === currentLoadingStep
          }"
        >
          <div class="icon_or_loader">
            <ng-container
              *ngIf="step.key === currentLoadingStep; else notLoading"
            >
              <!-- Custom loader or MatProgressBar showing progress -->
              <div class="loader-wrapper">
                <svg class="loader-circle" viewBox="0 0 36 36">
                  <path
                    class="circle-bg"
                    d="M18 2.0845
            a 15.9155 15.9155 0 0 1 0 31.831
            a 15.9155 15.9155 0 0 1 0 -31.831"
                    fill="none"
                    stroke="#f3f3f3"
                    stroke-width="4"
                  ></path>
                  <path
                    class="circle"
                    d="M18 2.0845
            a 15.9155 15.9155 0 0 1 0 31.831
            a 15.9155 15.9155 0 0 1 0 -31.831"
                    fill="none"
                    stroke="#3498db"
                    stroke-width="4"
                    stroke-linecap="round"
                    style="stroke-dasharray: 100, 100; stroke-dashoffset: 100"
                  ></path>
                </svg>
              </div>
            </ng-container>
            <ng-template #notLoading>
              <ng-container *ngIf="step.state === 'COMPLETED'; else showIcon">
                <mat-icon class="animated fadeIn">check</mat-icon>
              </ng-container>
              <ng-template #showIcon>
                <img
                  [src]="step.icon"
                  [alt]="getStepDisplayValue(step)"
                  width="20"
                />
              </ng-template>
            </ng-template>
          </div>

          <div class="loading_label">
            <!-- Existing conditions for step completion and loading states -->
            <p
              *ngIf="step.state === 'COMPLETED' && i !== steps.length - 1"
              class="animated fadeIn"
            >
              {{ getStepDisplayValue(step) }}
            </p>

            <p
              *ngIf="
                step.key === currentLoadingStep || step.state !== 'COMPLETED'
              "
            >
              {{ getStepDisplayValue(step) }}
              <span
                class="loading-dots"
                *ngIf="
                  step.state === 'COMPLETED' &&
                  displayExtendedLoader &&
                  i === steps.length - 1
                "
              >
                <span>.</span><span>.</span><span>.</span>
              </span>
              <span
                class="loading_number"
                *ngIf="
                  step.key === currentLoadingStep && step.state !== 'COMPLETED'
                "
                >({{ step.progress }}%)</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
